import { Directive, ElementRef, Input, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appPercentNumber]',
  host: {
    '(blur)': 'calculatePercent($event.target.value)'
  }
})
export class PercentNumberDirective {

  @Input("value") value: string;
  @Output() valueChange = new EventEmitter<string>();

  constructor(private _elementRef: ElementRef<HTMLInputElement>) { }

  calculatePercent(value: string) {
    var newVal = value;
    var actual;
    if (!newVal) {
      return '';
    }
    newVal = newVal.replace(/\D/g, '');
    if (newVal != null && newVal != '') {
      actual = parseInt(newVal);
      this.value = actual.toString() + '%';
    }
    else {
      this.value = null;
    }

    //Update input control and ngModel value
    this._elementRef.nativeElement.setAttribute('value', this.value);
    this.valueChange.emit(this.value);
  }
}
